import format from "date-fns/format";
import { Structure } from "../types";
import {
  eAmadeusDutyCodeOptions,
  eAmadeusOfficeOptions,
  eAmadeusSystemOptions,
  eAmadeusUserGroupOptions,
  eBizTitleOptions,
  eDepartmentOptions,
  eLocationOptions,
  eSystemTypeOptions,
  eTeamOptions,
  eTypeClassOptions,
  planOptions,
  sexOptions,
  typeVehicleOptions,
  unitOptions,
} from "./_options";
import {
  validateDataOptions,
  validateDate,
  validateEmail,
  validateGrantTerm,
  validateGrantedArea,
  validateNumber,
  validatePlainText,
  validateTripBusiness,
} from "./_utils";

export const SMALL_ITEM_SIZE = 15;
export const MEDIUM_ITEM_SIZE = 18;
export const LARGE_ITEM_SIZE = 22;

export const Users: Structure<{ Users: string }> = {
  header: "Người sử dụng",
  value: "",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const IdUser: Structure<{ IdUser: number }> = {
  header: "CMND/CCCD",
  value: 0,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateNumber,
};

export const PersonalId: Structure<{ personalId: number }> = {
  header: "CMND/CCCD/Hộ chiếu",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Email: Structure<{ Email: string }> = {
  header: "Email",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validateEmail,
};

export const Sex: Structure<{ sex: string }> = {
  header: "Giới tính",
  value: "",
  options: sexOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) =>
    validateDataOptions(value, sexOptions, `Giới tính phải là 'Nam' hoặc 'Nữ'. Giá trị hiện tại là '${value}'`),
};

export const Name: Structure<{ Name: string }> = {
  header: "Họ tên",
  value: "Nguyễn Văn A",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const FullName: Structure<{ FullName: string }> = {
  header: "Họ và tên",
  value: "Nguyễn Văn A",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const NameLowercase: Structure<{ name: string }> = {
  header: "Họ và tên",
  value: "Nguyễn Văn A",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const Position: Structure<{ Position: string }> = {
  header: "Chức danh",
  value: "KCQ",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const NameSupplies: Structure<{ NameSupplies: string }> = {
  header: "Mã nhân viên",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const FunctionCode: Structure<{ FunctionCode: string }> = {
  header: "Sân bay trực thuộc",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const WorkingDepartment: Structure<{ WorkingDepartment: string }> = {
  header: "Bộ phận công tác",
  value: "",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const SuggestionDetails: Structure<{ SuggestionDetails: string }> = {
  header: "Chi tiết đề nghị",
  value: "",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const DegreeTraining: Structure<{ DegreeTraining: string }> = {
  header: "Lý do",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const TypeClass: Structure<{ Class: string }> = {
  header: "Hạng ghế",
  value: "",
  options: eTypeClassOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eTypeClassOptions, "Hạng ghế không hợp lệ"),
};

export const TripBusiness: Structure<{ TripBusiness: string }> = {
  header: "Hành trình",
  value: `SGN-DAD (${format(new Date(), "d/M/yyyy HH:mm")})\nHAN-PQC (${format(new Date(), "d/M/yyyy HH:mm")})`,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateTripBusiness,
};

export const VehicleName: Structure<{ nameVehical: string }> = {
  header: "Tên phương tiện",
  value: "",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const LicensePlate: Structure<{ licensePlate: string }> = {
  header: "Biển kiếm soát",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const VehicleRegistrationCertificateId: Structure<{
  vehicleRegistrationCertificateId: number;
}> = {
  header: "Số giấy đăng ký phương tiện/Giấy phép khai thác thiết bị hàng không",
  value: 0,
  itemSize: LARGE_ITEM_SIZE,
  validate: validatePlainText,
};

export const CertificateOfInspectionId: Structure<{
  certificateOfInspectionId: number;
}> = {
  header:
    "Số chứng nhận kiểm định ATKT và BVMT giao thông/Biên bản kiểm định đủ tiêu chuẩn khai thác an toàn, kỹ thuật, môi trường",
  value: 0,
  itemSize: LARGE_ITEM_SIZE,
  validate: validatePlainText,
};

export const GrantTerm: Structure<{
  grantTerm: string;
}> = {
  header: "Thời hạn cấp",
  value: `${format(new Date(), "d/M/yyyy")} - ${format(new Date(), "d/M/yyyy")}`,
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validateGrantTerm,
};

export const GrantPeriod: Structure<{
  grantPeriod: string;
}> = {
  header: "Thời hạn cấp",
  value: `${format(new Date(), "d/M/yyyy")} - ${format(new Date(), "d/M/yyyy")}`,
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validateGrantTerm,
};

export const GrantedArea: Structure<{
  grantedArea: string;
}> = {
  header: "Khu vực đề nghị",
  value: "1-A; 1-Đỏ; 2; 2-A; 3-C; 4; 5; 6",
  itemSize: SMALL_ITEM_SIZE,
  validate: validateGrantedArea,
};

export const GateAway: Structure<{
  gateAway: string;
}> = {
  header: "Cổng vào",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Exit: Structure<{
  exit: string;
}> = {
  header: "Cổng ra",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const UnitPrice: Structure<{
  UnitPrice: number;
}> = {
  header: "Đơn giá",
  value: 0,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateNumber,
};

export const IntoMoney: Structure<{
  IntoMoney: number;
}> = {
  header: "Thành tiền",
  value: 0,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateNumber,
};

export const Team: Structure<{
  unit: string;
}> = {
  header: "Đội/Tổ",
  value: "Phòng Công nghệ thông tin",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const Unit: Structure<{
  unit: string;
}> = {
  header: "Đơn vị",
  options: unitOptions,
  value: "",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, unitOptions),
};

export const NumberOfVehicleLicensesIssued: Structure<{
  NumberOfVehicleLicensesIssued: string;
}> = {
  header: "Số giấy phép phương tiện đã cấp",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const DetailedDescriptionOfTheRequest: Structure<{
  DetailedDescriptionOfTheRequest: string;
}> = {
  header: "Chi tiết đề nghị",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Suggestions: Structure<{
  Suggestions: string;
}> = {
  header: "Đề nghị",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Request: Structure<{
  Request: string;
}> = {
  header: "Đề nghị",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const RequestingUnit: Structure<{
  RequestingUnit: string;
}> = {
  header: "Đơn vị đề nghị",
  value: "",
  itemSize: MEDIUM_ITEM_SIZE,
  validate: validatePlainText,
};

export const PhoneNumber: Structure<{
  PhoneNumber: number;
}> = {
  header: "Số điện thoại",
  value: 0,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateNumber,
};

export const StartDate: Structure<{
  StartDate: string;
}> = {
  header: "Thời gian bắt đầu",
  value: "'" + format(new Date(), "d/M/yyyy HH:mm"),
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDate(value, "d/M/yyyy HH:mm"),
};

export const EndDate: Structure<{
  EndDate: string;
}> = {
  header: "Thời gian kết thúc",
  value: "'" + format(new Date(), "d/M/yyyy HH:mm"),
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDate(value, "d/M/yyyy HH:mm"),
};

export const TripItinerary: Structure<{
  TripItineraty: string;
}> = {
  header: "Hành trình",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const TypeVehicle: Structure<{
  TypeVehicle: string;
}> = {
  header: "Loại xe",
  options: typeVehicleOptions,
  value: "",
  itemSize: 20,
  validate: (value) => validateDataOptions(value, typeVehicleOptions),
};

export const Amount: Structure<{
  Amount: number;
}> = {
  header: "Số lượng",
  value: 0,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateNumber,
};

export const Reason: Structure<{
  Reason: string;
}> = {
  header: "Lý do sử dụng xe công vụ",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Content: Structure<{
  Content: string;
}> = {
  header: "Nội dung",
  value: "Nội dung mẫu",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const SuggestedQuantity: Structure<{
  SuggestedQuantity: string;
}> = {
  header: "Số lượng đề nghị",
  value: 1,
  itemSize: SMALL_ITEM_SIZE,
  validate: validateNumber,
};

export const EstimatedTimeOfUse: Structure<{
  EstimatedTimeOfUse: string;
}> = {
  header: "Thời gian dự kiến sử dụng",
  value: "'" + format(new Date(), "d/M/yyyy"),
  itemSize: SMALL_ITEM_SIZE,
  validate: validateDate,
};

export const Note: Structure<{
  note: string;
}> = {
  header: "Ghi chú",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Notes: Structure<{
  Notes: string;
}> = {
  header: "Ghi chú",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExplanatoryNotes: Structure<{
  Notes: string;
}> = {
  header: "Ghi chú/Giải trình",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const EmployeeCode: Structure<{
  EmployeeCode: string;
}> = {
  header: "Mã nhân viên",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const CaseHasBeenGranted: Structure<{
  CaseHasBeenGranted: string;
}> = {
  header: "User ID",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const CodePcc: Structure<{
  CodePcc: string;
}> = {
  header: "Sân bay trực thuộc",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const PhotoContract: Structure<{
  photoContract: string;
}> = {
  header: "Bản photo hợp đồng",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Plan: Structure<{
  Plan: string;
}> = {
  header: "Nguồn vật tư",
  value: "",
  options: planOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, planOptions),
};

export const Regency: Structure<{
  regency: string;
}> = {
  header: "Chức vụ",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const KSANCardNumberIssued: Structure<{
  KSANCardNumberIssued: string;
}> = {
  header: "Số thẻ KSAN đã cấp",
  value: "",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};
// THU HỒI CCDC
export const ToolReason: Structure<{ ToolReason: string }> = {
  header: "Lí do",
  value: "Nhập",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ToolName: Structure<{ ToolName: string }> = {
  header: "Tên CCDC",
  value: "Tên CCDC",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ToolCode: Structure<{ ToolCode: string }> = {
  header: "Mã CCDC",
  value: "Mã CCDC",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ToolQuantity: Structure<{ ToolQuantity: string }> = {
  header: "Số lượng",
  value: "5",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ToolUnit: Structure<{ ToolUnit: string }> = {
  header: "ĐVT",
  value: "Cái",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExportWarehouseName: Structure<{ ExportWarehouseName: string }> = {
  header: "Tên vật tư/ hàng hóa",
  value: "Bàn phím",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ChangePersonRegister: Structure<{ ChangePersonRegister: string }> = {
  header: "Nhân sự/ mã NV đã đăng ký",
  value: "MA123",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExportWarehouseUnit: Structure<{ ExportWarehouseUnit: string }> = {
  header: "ĐVT",
  value: "Cái",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ChangePersonReplace: Structure<{ ChangePersonReplace: string }> = {
  header: "Nhân sự/ mã NV thay thế/ bổ sung",
  value: "MA456",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExportWarehouseRequestQuantity: Structure<{ ExportWarehouseRequestQuantity: string }> = {
  header: "Số lượng đề nghị",
  value: "10",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ChangePersonDepartment: Structure<{ ChangePersonReplace: string }> = {
  header: "Cơ quan/ Đơn vị",
  value: "Phòng Kế hoạch đầu tư",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExportWarehouseExistQuantity: Structure<{ ExportWarehouseExistQuantity: string }> = {
  header: "Số lượng tồn tại đơn vị",
  value: "25",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExportWarehouseTimeUse: Structure<{ ExportWarehouseTimeUse: string }> = {
  header: "Thời gian sử dụng",
  value: "20/1/2021",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ExportWarehouseNote: Structure<{ ExportWarehouseNote: string }> = {
  header: "Ghi chú",
  value: "Nội dung ghi chú",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const ChangePersonReason: Structure<{ ChangePersonReplace: string }> = {
  header: "Lý do thay đổi",
  value: "Nhập lý do",
  itemSize: SMALL_ITEM_SIZE,
  validate: validatePlainText,
};

export const Department: Structure<{ eDepartment: string }> = {
  header: "Phòng ban",
  value: "",
  options: eDepartmentOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eDepartmentOptions, "Phòng ban không hợp lệ"),
};

export const BizTitle: Structure<{ eBizTitle: string }> = {
  header: "Chức danh",
  value: "",
  options: eBizTitleOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eBizTitleOptions, "Chức danh không hợp lệ"),
};

export const Location: Structure<{ eLocation: string }> = {
  header: "Vị trí",
  value: "",
  options: eLocationOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eLocationOptions, "Vị trí không hợp lệ"),
};

export const SystemType: Structure<{ eSystemType: string }> = {
  header: "Loại quy trình",
  value: "",
  options: eSystemTypeOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eSystemTypeOptions, "Loại quy trình không hợp lệ"),
};

export const SystemTeam: Structure<{ eTeam: string }> = {
  header: "Nhóm phát triển",
  value: "",
  options: eTeamOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eTeamOptions, "Nhóm phát triển không hợp lệ"),
};

export const AmadeusSystem: Structure<{ System: string }> = {
  header: "Hệ thống",
  value: "",
  options: eAmadeusSystemOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eAmadeusSystemOptions, "Hệ thống không hợp lệ"),
};

export const AmadeusGroupUser: Structure<{ FunctionCode: string }> = {
  header: "Nhóm User",
  value: "",
  options: eAmadeusUserGroupOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eAmadeusUserGroupOptions, "Nhóm User không hợp lệ"),
};

export const AmadeusDutyCode: Structure<{ DutyCode: string }> = {
  header: "Duty Code",
  value: "",
  options: eAmadeusDutyCodeOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eAmadeusDutyCodeOptions, "Duty Code không hợp lệ"),
};

export const AmadeusOffice: Structure<{ Office: string }> = {
  header: "Office",
  value: "",
  options: eAmadeusOfficeOptions,
  itemSize: SMALL_ITEM_SIZE,
  validate: (value) => validateDataOptions(value, eAmadeusOfficeOptions, "Office không hợp lệ"),
};
